import * as React from 'react';
import { connect } from 'react-redux';
import { setTiposPublicacion } from '../../../actions/tiposPublicacionActions';
import { fetchTiposPublicacion } from '../../../actions/tiposPublicacionActions';
import { withNavigation } from '../../General/withNavigation';
import { selectSellerMerged } from '../../../helper/sellerMergedSelector';

class TiposParaGuardar extends React.Component {
    constructor() {
        super();
        this.state = {
            listaIdTiposPublicaciones: []
        }
    };

    componentDidMount() {
        const id = this.props.seller?.codigo;
        const idNum = parseInt(id, 10);
        if (!id || !Number.isFinite(idNum) || idNum <= 0) {
            return;
        }
        if (!this.props.loadedSellerTabTipo || !Array.isArray(this.props.settedTiposPublicacion) || this.props.settedTiposPublicacion.length === 0) {
            this.props.fetchTiposPublicacion(idNum);
        }
    }

    borrarFila = (codigo) => {
        let jsonSetted = JSON.stringify(this.props.settedTiposPublicacion);
        if (jsonSetted != "[]" && jsonSetted != "{}") {
            let index = this.props.settedTiposPublicacion.findIndex(x => x.codigo == codigo);
            this.props.settedTiposPublicacion.splice(index, 1);
            this.props.setTiposPublicacion(this.props.settedTiposPublicacion);
            this.forceUpdate();
        } else {
            let index = this.props.tiposPublicacionesAsignados.findIndex(x => x.codigo == codigo);
            this.props.tiposPublicacionesAsignados.splice(index, 1);
            this.props.setTiposPublicacion(this.props.tiposPublicacionesAsignados);
            this.forceUpdate();
        }
    }

    setRows = () => {
        var rows = [];
        let htmlData;
        this.props.settedTiposPublicacion.map((item, i) => {
            htmlData =
                <tr key={i} className="hover-background-color">
                    <td className="div-center">{item.codigo}</td>
                    <td className="div-center">{item.descripcion}</td>
                    <td className="div-center">{item.comision}</td>
                    <td onClick={() => this.borrarFila(item.codigo)}>
                        <i className="fas fa-trash-alt" />
                    </td>
                </tr>
            rows.push(htmlData)
        });
        return rows;
    }

    filaTipos = () => {

        if (this.props.location?.pathname === "/Sellers/Nuevo") {
            return [];
        }

        if (Array.isArray(this.props.settedTiposPublicacion) && this.props.settedTiposPublicacion.length > 0) {

            var rows = [];
            let htmlData;
            this.props.settedTiposPublicacion.map((item, i) => {

                if (JSON.stringify(item) != "{}") {
                    htmlData =
                        <tr key={i} className="hover-background-color">
                            <td className="div-center">
                                <h6 className="box-title m-b-5 font-weight-bold">{item.codigo}</h6>
                            </td>
                            <td className="div-center">{item.descripcion}</td>
                            <td className="div-center">
                                <small className="font-14 applyFont">
                                    <i className="font-size-072rem fas fa-percent" /> {item.comision}
                                </small>
                            </td>
                            <td
                                key={i}
                                onClick={() => this.borrarFila(item.codigo)}
                                hidden={this.props.tipoUsuario !== 2}
                            >
                                <i className="fas fa-trash-alt" />
                            </td>
                        </tr>
                    rows.push(htmlData)
                }
            });
            return rows;
        } else {
            // setTimeout(() => { this.props.setTiposPublicacion(this.props.tiposPublicacionesAsignados) }, 500)
            // setTimeout(() => { this.setRows() }, 500)
        }
    }


    render() {
        return (
            <div>

                <div className="col-md-5 align-self-center">
                    <h4 className="card-title">Lista de Tipo Publicaciones</h4>
                </div>

                <div>
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="div-center">#</th>
                                <th className="div-center">Descripción</th>
                                <th className="div-center">Comisión</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.filaTipos()
                            }
                        </tbody>
                    </table>
                </div>

            </div>
        );
    }
}

const mapStateToProps = state => ({
    seller: selectSellerMerged(state),
    idSeller: state.general.idSeller,
    tipoUsuario: state.general.tipoUsuario,
    tiposPublicacionesAsignados: state.publicaciones.tiposPublicacion,
    //loadedSellerTabTipo: state.publicaciones.loadedSellerTabTipo,
    loadedSellerTabTipo: state.tiposPublicacion.loadedSellerTabTipo,
    editando: state.general.editando,
    settedTiposPublicacion: state.tiposPublicacion.setTiposPublicacion
    //settedTiposPublicacion: state.publicaciones.tiposPublicacion
});

export default withNavigation(connect(mapStateToProps, {
    fetchTiposPublicacion,
    setTiposPublicacion
})(TiposParaGuardar));

